import { BCMSRecord, DisabledPrompt, Link, useBCMSContext } from "@bcm-dev/bcms-vite";
import EDEStatementsPageContainer from "components/EDEStatements/shared/containers/EDEStatementsPageContainer";
import EDEStatementsPageContentView from "components/EDEStatements/shared/views/EDEStatementsPageContentView";
import { CenterContentContainer, ContentHeaderView, TableBody, TableColumnContainer, TableColumnView, TableView } from 'components/shared';
import Classes from "model";
import React from "react";
import "./styles.css";
import "./mobile.css";


/**
 * @function EDEAccountAccessPage
 * @return {React.Component}
 * @exported true
 * @description The ede "Account Access" page.
 */

export default function EDEAccountAccessPage(props) {
  // Initalize all model classes
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);

  // Sets the values for the data and ui variables
  const data = { ...getDefaultPageData(), ...props.data ?? {} };
  const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };
  // The state to be passed to the state manager
  const state = { data, ui };
  
  // :: React.state, React.setState -> OBJECT
  // Function to initalize the controller for the state manager
  const controller = (state, setState) => ({
      data: state.data, // Set the data property of the controller
      ui: state.ui, // Set the ui property of the controller
      
  });
  
  return(
    <EDEStatementsPageContainer className={ `ede-account-access-page` } state={ state } controller={ controller }>
        <PageContent/>
    </EDEStatementsPageContainer>
  );
}

/**
 * @name getDefaultPageData
 * @param {Void} 
 * @returns {OBJECT}
 * @description Hook to return the default data required by the page
 */
export const getDefaultPageData = () => {

  return {}
};

/**
* @name getDefaultPageUI
* @param {Void} 
* @return {OBJECT}
* @description Hook to return the default ui required by the page.
*/
export const getDefaultPageUI = () => ({
  // no ui changes for now
  
});

function PageContent(props) {
  const subheader = `You can give others access to your statements. For example, you may want to allow
  your accountant or children to view your statements. A confirmation email and statement notification
  will be sent to the email address you provide for that person. Please note that the bank is not responsible
  for statement access by non-account holders or any errors made while adding new users.`;

  return (
    <EDEStatementsPageContentView>
      <div className="ede-others-statements-page-container flex-container flex-vertical flex-width">
        <CenterContentContainer>
          <ContentHeaderView text="Account Access" />
          <p className="subheader">{ subheader }</p>
          <TableView className="ede-others-statements-table">
              <TableColumnContainer>
                  <TableColumnView className="text-left date" text={ "Access" } />
                  <TableColumnView className="text-left description" text={ "Name" } />
                  <TableColumnView className="actions-column" text={ "Email" } />
                  <TableColumnView className="actions-column" text={ "Phone Number" } />
                  <TableColumnView className="actions-column" text={ "Short Description" } />
              </TableColumnContainer>
              <TableBody>
                  { undefined }
                  <tr>
                    <td className="text-center table-item-view" colSpan="5"></td>
                  </tr>
                  <tr>
                    <td className="text-center table-item-view" colSpan="5"></td>
                  </tr>
              </TableBody>
              
          </TableView>
          <DisabledPrompt>
            <Link>Add New Account Access</Link>
          </DisabledPrompt>
        </CenterContentContainer>
      </div>
    </EDEStatementsPageContentView>
  );
}
